let accordeon = {
    init() {
        // $('.title-accordeon').click(function(){
        //     $('.text-accordeon').slideUp(300);
        //     $('.title-accordeon').removeClass('active');

        //     $(this).toggleClass('active');
        //     $(this).next().slideToggle(300);
        // })


        setTimeout(function () {
            var nb = $('.title-accordeon').length;
            //console.log(nb);

            if (nb > 0) {
                $('.title-accordeon').click(function () {
                    if ($(this).hasClass('active')) {
                        $(this).removeClass('active');
                        $(this).next().slideUp(300);

                    } else {
                        $('.title-accordeon').removeClass('active');
                        $(this).addClass('active');
                        $('.text-accordeon').slideUp(300);
                        $(this).next().slideDown(300);
                    }
                })


                if (location.hash != '') {
                    var id = location.hash;
                    $('html, body').animate({scrollTop: $(location.hash).offset().top}, 500);
                    $(id).toggleClass('active');
                    $(id).next().slideToggle(300);
                }
            }
        }, 500);
    }
}

export default accordeon;
